import '@angular/compiler';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageOverviewComponent } from './page.overview/page.overview.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageAnalysisComponent } from './page.analysis/page.analysis.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageSamplesComponent } from './page.samples/page.samples.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';

const INDEX_PAGE = "overview";

const LEGACY_REDIRECTS: Routes = [
    {
        path: 'dashboard',
        pathMatch: 'full',
        redirectTo: INDEX_PAGE
    }
];

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "overview",
                component: PageOverviewComponent,
                "app_id": "page.overview"
            },
            {
                "path": "analysis",
                component: PageAnalysisComponent,
                "app_id": "page.analysis"
            },
            {
                "path": "samples/:sample?",
                component: PageSamplesComponent,
                "app_id": "page.samples"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [
    ...LEGACY_REDIRECTS,
    {
        matcher: (url: any) => {
            for (let i = 0; i < app_routes.length; i++) {
                let layout = app_routes[i];
                let layout_childs = layout.children;
                for (let j = 0; j < layout_childs.length; j++) {
                    let child = layout_childs[j];
                    let matcher = patternMatcher(child.path, url);
                    if (matcher)
                        return null;
                }
            }
            return { consumed: url, posParams: {} };
        },
        redirectTo: INDEX_PAGE
    }
];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }